export default __webpack_public_path__ + "static/media/analysis.047a8cd6.svg";